<template>
  <div v-if="Object.keys(info).length" class="print-layout" :style="style.printLayout">
    <div>
      <span class="layout-title" :style="style.title">Dados do pedido</span>

      <span v-if="type === 'entrega'" class="status-box" :style="style.statusBoxEntrega">{{ capitalize(type) }}</span>
      <span v-else class="status-box" :style="style.statusBoxRetirada">{{ capitalize(type) }}</span>
      <span class="status" :style="style.status">Status atual: {{ info.status | status }}</span>
    </div>

    <div class="box" :style="style.box">
      <p class="layout-label" :style="style.label">Responsável</p>
      <p class="text" :style="style.text">{{ info.agent }}</p>
    </div>

    <div class="box" :style="style.box">
      <p v-if="type === 'entrega'" class="layout-label" :style="style.label">Data/hora da entrega</p>
      <p v-else-if="type === 'retirada'" class="layout-label" :style="style.label">Data/hora da retirada</p>
      <p class="text" :style="style.text">
        {{ (info.date && DateTime.fromFormat(info.date, 'yyyy-MM-dd').toFormat('dd/MM/yyyy')) || '-' }} | {{ info.time || '-' }}
      </p>
    </div>

    <div>
      <p class="layout-label" :style="style.label">Anotações</p>
      <p class="text" :style="style.text">
        {{ info.annotations || '-' }}
      </p>
    </div>

    <div v-if="type === 'entrega'">
      <p class="layout-label" :style="style.label">Endereço de entrega</p>
      <p class="text" :style="style.text">
        {{ info.user.address | address }}
      </p>
    </div>

    <div v-if="type === 'retirada'">
      <p class="layout-label" :style="style.label">Endereço para retirada</p>
      <p class="text" :style="style.text">{{ info.unit.name }} - {{ info.unit.address }}</p>
    </div>

    <hr />

    <h2 class="layout-title" :style="style.title">Dados do cliente</h2>

    <div>
      <div class="box" :style="style.box">
        <p class="layout-label" :style="style.label">Nome do cliente</p>
        <p class="text" :style="style.text">{{ info.user.name }}</p>
      </div>
      <div class="box" :style="style.box">
        <p class="layout-label" :style="style.label">Data/hora do pedido</p>
        <p class="text" :style="style.text">{{ DateTime.fromISO(info.purchase.timestamp).toFormat('dd/MM/yyyy | HH:mm') }}</p>
      </div>
      <div class="box" :style="style.box">
        <p class="layout-label" :style="style.label">Forma de pagamento</p>
        <p class="text" :style="style.text">{{ info.purchase.payment.payment_method | paymentMethod }}</p>
      </div>
    </div>

    <div>
      <div class="box" :style="style.box">
        <p class="layout-label" :style="style.label">Número</p>
        <p class="text" :style="style.text">{{ info.user.phone | telefone }}</p>
      </div>
      <div class="box" :style="style.box">
        <p class="layout-label" :style="style.label">CPF na nota?</p>
        <p class="text" :style="style.text">{{ info.purchase.document_on_fiscal_note | yesOrNo }}</p>
      </div>
      <div class="box" :style="style.box">
        <p class="layout-label" :style="style.label">Valor da compra</p>
        <p class="text" :style="style.text">
          R$ {{ info.purchase.cart.total_value | localeString(2) }}
          <span>(+ R$ {{ info.purchase.rate | localeString(2) }} de taxa)</span>
        </p>
      </div>
    </div>

    <div>
      <div class="box" :style="style.box">
        <p class="layout-label" :style="style.label">CPF</p>
        <p v-if="info.user.document_no.length === 11" class="text" :style="style.text">{{ info.user.document_no | cpf }}</p>
        <p v-else class="text" :style="style.text">{{ info.user.document_no | cnpj }}</p>
      </div>
      <div class="box" :style="style.box">
        <p class="layout-label" :style="style.label">Troca de produtos</p>
        <p class="text" :style="style.text">{{ info.purchase.missing_product_policy | missingProductPolicy }}</p>
      </div>
      <div class="box" :style="style.box">
        <p class="layout-label" :style="style.label">Fidelidade?</p>
        <p class="text" :style="style.text">{{ info.loyalty | yesOrNo }}</p>
      </div>
    </div>

    <hr />

    <h2 class="layout-title" :style="style.title">
      Lista de produto(s) ({{ info.purchase.cart.products.length }} {{ info.purchase.cart.products.length === 1 ? 'produto' : 'produtos' }})
    </h2>

    <table style="width: 100%">
      <tr>
        <th class="table-header" :style="style.tableHeader">Nome</th>
        <th class="table-header" :style="style.tableHeader">EAN</th>
        <th class="table-header" :style="style.tableHeader">Quantidade</th>
        <th class="table-header" :style="style.tableHeader">Valor unitário</th>
        <th class="table-header" :style="style.tableHeader">Valor total</th>
      </tr>
      <tr v-for="(product, index) in orderBy(info.purchase.cart.products, 'name', 'asc')" :key="index">
        <td class="table-item" :style="style.tableItem">{{ product.name }}</td>
        <td class="table-item" :style="style.tableItem">{{ product.ean }}</td>
        <td class="table-item" :style="style.tableItem">{{ product.quantity }}</td>
        <td class="table-item" :style="style.tableItem">R${{ product.unit_value | localeString(2) }}</td>
        <td class="table-item" :style="style.tableItem">R${{ product.total_value | localeString(2) }}</td>
      </tr>
    </table>
  </div>
</template>

<script>
import { orderBy, capitalize } from 'lodash'
import { DateTime } from 'luxon'

export default {
  filters: {
    yesOrNo(value) {
      return value ? 'Sim' : 'Não'
    },
    paymentMethod(value) {
      switch (value) {
        case 'CASH':
          return 'Dinheiro'
        case 'DEBIT_CARD':
          return 'Cartão de débito'
        case 'CREDIT_CARD':
          return 'Cartão de crédito'
      }
    },
    missingProduct(value) {
      switch (value) {
        case 'CANCEL':
          return value
        case 'SWAP':
          return value
        case 'REMOVE':
          return value
      }
    },
    status(value) {
      switch (value) {
        case 'OPEN':
          return 'Aberto'
        case 'CONFIRMED':
          return 'Confirmado'
        case 'SEPARATION':
          return 'Separação'
        case 'AWAITING':
          return 'Preparado'
        case 'CONCLUDED':
          return 'Concluído'
        case 'CANCELED':
          return 'Cancelado'
      }
    },
    missingProductPolicy(value) {
      switch (value) {
        case 'CANCEL':
          return 'Cancele todo o pedido.'
        case 'SWAP':
          return 'Escolha o mesmo produto de outra marca.'
        case 'REMOVE':
          return 'Não escolha outro produdo.'
      }
    },
    address(value) {
      let address = ''

      if (value.postal_code) {
        const formatted_postal_code = value.postal_code.replace(/[^\d]/g, '').replace(/(\d{5})(\d{3})/, '$1-$2')
        address += formatted_postal_code + ', '
      }
      if (value.neighborhood) address += value.neighborhood + ', '
      if (value.street) address += value.street + ', '
      if (value.number) address += value.number + ', '
      if (value.complement) address += value.complement + ', '
      if (value.city_name) address += value.city_name + ', '
      if (value.federative_unit) address += value.federative_unit

      return address
    },
  },
  props: {
    info: Object,
  },
  data: () => ({
    DateTime: DateTime,
    orderBy: orderBy,
    capitalize: capitalize,
    style: {
      printLayout: {
        fontFamily: 'Lato, sans-serif',
        padding: '20px',
      },
      box: {
        width: '30%',
        display: 'inline-block',
      },
      title: {
        opacity: '0.8',
        fontSize: '18px',
        fontWeight: 'bold',
        textAlign: 'left',
        color: '#000000',
      },
      label: {
        opacity: '0.8',
        fontSize: '15px',
        fontWeight: 'bold',
        textAlign: 'left',
        color: '#000000',
      },
      text: {
        opacity: '0.8',
        fontSize: '12px',
        fontWeight: 'normal',
        textAlign: 'left',
        color: '#000000',
      },
      tableHeader: {
        borderBottom: '1px solid #ddd',
        textAlign: 'left',
        opacity: '0.5',
        fontSize: '12px',
        fontWeight: 'bold',
        color: '#000000',
      },
      tableItem: {
        borderBottom: '1px solid #ddd',
        opacity: '0.8',
        fontSize: '12px',
        fontWeight: 'normal',
        textAlign: 'left',
        color: '#000000',
        paddingBottom: '4px',
        paddingTop: '4px',
      },
      statusBoxEntrega: {
        padding: '4px',
        borderRadius: '3px',
        fontSize: '12px',
        fontWeight: 'bold',
        lineHeight: '1.25',
        color: '#ffffff',
        backgroundColor: '#00b395',
        marginLeft: '15px',
      },
      statusBoxRetirada: {
        padding: '4px',
        borderRadius: '3px',
        fontSize: '12px',
        fontWeight: 'bold',
        lineHeight: '1.25',
        color: '#ffffff',
        backgroundcolor: '#3498db',
        marginLeft: '15px',
      },
      status: {
        opacity: '0.5',
        fontSize: '12px',
        lineHeight: '1.25',
        letterSpacing: '0.19px',
        color: '#000000',
        marginLeft: '15px',
      },
    },
  }),
  computed: {
    type() {
      return this.info.purchase.delivery_method === 'DELIVERY' ? 'entrega' : 'retirada'
    },
  },
}
</script>
